import { useState } from "react";
import { submitForm } from "../utils/googleSheet";
import { CONTACT } from "../utils/contact";
import "./ServiceForm.css";

const INITIAL_FORM = {
  name: "",
  phone: "",
  whatsappPreferred: false,
  location: "",
  city: "",
  service: "",
  propertyType: "",
  problem: "",
  preferredDateTime: "",
  referral: "",
};

const SERVICES = [
  "AC Technician",
];

const PROPERTY_TYPES = [
  "House",
  "Apartment",
  "Office",
  "Shop",
  "Other",
];

const CITIES = ["Kamra", "Attock", "Other"];

const REFERRAL_OPTIONS = [
  "WhatsApp",
  "Social media",
  "Saw a poster",
  "Colleague / friend referral",
  "Other",
];

export default function ServiceForm() {
  const [form, setForm] = useState(INITIAL_FORM);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    setError("");

    try {
      await submitForm({
        ...form,
        submittedAt: new Date().toISOString(),
        source: "maskanh-website",
      });
      setStatus("success");
      setForm(INITIAL_FORM);
    } catch (err) {
      setStatus("error");
      setError(
        err.message ||
          `Something went wrong. Please try again or WhatsApp us at ${CONTACT.phone}.`
      );
    }
  };

  return (
    <section className="form-section" id="request-form">
      <div className="container form-layout">
        <div className="form-intro">
          <span className="section-label">Book a Verified Technician</span>
          <h2 className="section-title">Find To Verified Technicians 
</h2>
          <p className="section-subtitle">
            Fill in your details below and we will confirm a verified technician
            via WhatsApp within 30 minutes. (Kamra · Attock)
          </p>

          <ul className="form-benefits">
            <li>✓ Verified technicians only</li>
            <li>✓ WhatsApp confirmation in 30 min</li>
            <li>✓ No account required</li>
            <li>✓ Data saved securely to our system</li>
          </ul>
        </div>

        <div className="form-card">
          {status === "success" ? (
            <div className="form-success">
              <div className="form-success-icon">✓</div>
              <h3>Request Submitted!</h3>
              <p>
                Thank you! We&apos;ll confirm your booking via WhatsApp within
                30 minutes.
              </p>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => setStatus("idle")}
              >
                Submit Another Request
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="service-form">
              <div className="form-row">
                <div className="form-field">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    placeholder="Your full name"
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-field">
                  <label htmlFor="phone">Phone Number *</label>
                  <input
                    id="phone"
                    name="phone"
                    type="tel"
                    placeholder="03XX XXXXXXX"
                    value={form.phone}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <label className="form-checkbox">
                <input
                  name="whatsappPreferred"
                  type="checkbox"
                  checked={form.whatsappPreferred}
                  onChange={handleChange}
                />
                <span>WhatsApp Preferred</span>
              </label>

              <div className="form-row">
                <div className="form-field">
                  <label htmlFor="city">City *</label>
                  <select
                    id="city"
                    name="city"
                    value={form.city}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select city</option>
                    {CITIES.map((city) => (
                      <option key={city} value={city}>
                        {city}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-field">
                  <label htmlFor="propertyType">Property Type</label>
                  <select
                    id="propertyType"
                    name="propertyType"
                    value={form.propertyType}
                    onChange={handleChange}
                  >
                    <option value="">Select type</option>
                    {PROPERTY_TYPES.map((type) => (
                      <option key={type} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-field">
                <label htmlFor="location">Your Location / Address *</label>
                <input
                  id="location"
                  name="location"
                  type="text"
                  placeholder="Street, area, landmark. Be specific."
                  value={form.location}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-field">
                <label htmlFor="service">Service Required *</label>
                <select
                  id="service"
                  name="service"
                  value={form.service}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a service</option>
                  {SERVICES.map((svc) => (
                    <option key={svc} value={svc}>
                      {svc}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-field">
                <label htmlFor="problem">Describe the Problem</label>
                <textarea
                  id="problem"
                  name="problem"
                  rows={3}
                  placeholder="Help the technician prepare before arrival"
                  value={form.problem}
                  onChange={handleChange}
                />
              </div>

              <div className="form-field">
                <label htmlFor="preferredDateTime">Preferred Date &amp; Time</label>
                <input
                  id="preferredDateTime"
                  name="preferredDateTime"
                  type="text"
                  placeholder="e.g. 'Today after 4pm', 'Tomorrow morning'"
                  value={form.preferredDateTime}
                  onChange={handleChange}
                />
              </div>

              <div className="form-field">
                <label htmlFor="referral">How did you hear about us?</label>
                <select
                  id="referral"
                  name="referral"
                  value={form.referral}
                  onChange={handleChange}
                >
                  <option value="">Select an option</option>
                  {REFERRAL_OPTIONS.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              </div>

              {error && <p className="form-error">{error}</p>}

              <button
                type="submit"
                className="btn btn-primary form-submit"
                disabled={status === "loading"}
              >
                {status === "loading" ? "Submitting..." : "Request Service"}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
